const ArrowIcon = () => {
  return (
    <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.248152 0.248152C-0.0827175 0.579023 -0.0827175 1.11547 0.248152 1.44634L4.35598 5.55417L0.248152 9.66199C-0.0827175 9.99286 -0.0827175 10.5293 0.248152 10.8602C0.579023 11.191 1.11547 11.191 1.44634 10.8602L6.15326 6.15326C6.48413 5.82239 6.48413 5.28594 6.15326 4.95507L1.44634 0.248152C1.11547 -0.0827175 0.579023 -0.0827175 0.248152 0.248152Z"
        fill="#19191A"
      />
    </svg>
  )
}

export default ArrowIcon
